import { TOAST_TYPES } from '@/js/toast-messages/container/ToastMessages'

class Wishlist {
    static LOCAL_STORAGE_KEY = 'wishlist';
    static MAX_ITEMS = 25;

    constructor() {
        this.cleanUpLocalStorage();
    }

    // CLEANUP
    cleanUpLocalStorage() {
        const currentWishlist = this.readLocalStorage(Wishlist.LOCAL_STORAGE_KEY);
        const uniqueWishlist = [];
        const seenVariantIds = new Set();

        currentWishlist.forEach((item) => {
            // remove everything that doesn't conform to the expected shape anymore
            if (item && item.variantId) {
                // remove duplicates based on variantId

                if (!seenVariantIds.has(item.variantId)) {
                    seenVariantIds.add(item.variantId);
                    uniqueWishlist.push(item);
                }
            }
        });

        localStorage.setItem(Wishlist.LOCAL_STORAGE_KEY, JSON.stringify(uniqueWishlist));
    }

    /**
     * READING & RETRIEVING FROM LOCAL STORAGE
     */

    readLocalStorage() {
        const wishlist = localStorage.getItem(Wishlist.LOCAL_STORAGE_KEY);
        if (wishlist) {
            return JSON.parse(wishlist);
        }
        return [];
    }

    getProduct(variantId) {
        const wishlist = this.readLocalStorage();
        return wishlist.find(item => item.variantId === variantId);
    }

    getAllProducts() {
        return this.readLocalStorage()
    }

    isOnWishlist(variantId) {
        return this.getProduct(variantId) !== undefined;
    }

    /**
     * ADDING & REMOVING FROM LOCAL STORAGE
     */

    addProduct(productData) {
        const wishlist = this.readLocalStorage();

        // don't add it, if the wishlist is full
        if (wishlist.length >= Wishlist.MAX_ITEMS) {
            window.dispatchEvent(new CustomEvent('toast', { detail: {
                message: `Es können maximal ${Wishlist.MAX_ITEMS} Produkte auf dem Wunschzettel gespeichert werden.`,
                type: TOAST_TYPES.wishlistAdded,
            } }));

            return
        }

        // don't add the product if it's already in the wishlist
        if (!wishlist.includes(productData)) {
            wishlist.push(productData);
            localStorage.setItem(Wishlist.LOCAL_STORAGE_KEY, JSON.stringify(wishlist));

            window.dispatchEvent(new CustomEvent('toast', { detail: {
                message: 'Das Produkt wurde zum Wunschzettel hinzugefügt!',
                type: TOAST_TYPES.wishlistAdded,
            } }));
        }
    }

    removeProductByVariantId(variantId) {
        const wishlist = this.readLocalStorage();

        // remove all products with the same handle
        const filtered = wishlist.filter(item => item.variantId !== variantId);
        localStorage.setItem(Wishlist.LOCAL_STORAGE_KEY, JSON.stringify(filtered));

        window.dispatchEvent(new CustomEvent('toast', { detail: {
            message: 'Das Produkt wurde vom Wunschzettel entfernt!',
            type: TOAST_TYPES.wishlistAdded,
        } }));
    }
}

export const wishlist = new Wishlist();